import { memo } from 'react';

import { useShortIdContext } from '@air/provider-short-id';

import { PublicAssetModalInfoPanelContent } from '~/components/PublicAssetModal/components/PublicAssetModalInfoPanelContent';

export const PublicAssetModalInfoPanel = memo(() => {
  const { presentationSettings, shortId } = useShortIdContext();

  if (presentationSettings?.hideInfoTab) {
    return null;
  }

  return <PublicAssetModalInfoPanelContent shortId={shortId} />;
});

PublicAssetModalInfoPanel.displayName = 'PublicAssetModalInfoPanel';
